"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isArray = _interopRequireDefault(require("transmute/isArray"));

var _immutable = require("immutable");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ActionFormActionTypes = _interopRequireDefault(require("crm_ui/flux/integrations/ActionFormActionTypes"));

var _ActionFormAPI = _interopRequireDefault(require("crm_ui/api/integrations/ActionFormAPI"));

var _default = {
  dynamicFormChanged: function dynamicFormChanged(actionFormData, values) {
    var appId = actionFormData.get('appId');
    var formId = actionFormData.get('formId');
    var contactId = actionFormData.get('contactId');
    (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.DYNAMIC_FORM_REQUESTED, (0, _immutable.fromJS)({
      appId: appId,
      contactId: contactId,
      formId: formId
    }));
    return _ActionFormAPI.default.fetchDynamicForm(appId, formId, contactId, values).then(function (dynamicFormInstance) {
      return (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.DYNAMIC_FORM_FETCHED, (0, _immutable.fromJS)({
        appId: appId,
        contactId: contactId,
        dynamicFormInstance: dynamicFormInstance,
        formId: formId
      }));
    }).catch(function () {
      return (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.DYNAMIC_FORM_FETCH_FAILED, (0, _immutable.fromJS)({
        appId: appId,
        contactId: contactId,
        formId: formId
      }));
    });
  },
  fetchInstance: function fetchInstance(appId, formId, contactId) {
    (0, _Dispatch.dispatchQueue)(_ActionFormActionTypes.default.INSTANCE_REQUESTED, (0, _immutable.fromJS)({
      appId: appId,
      contactId: contactId,
      formId: formId
    })).done();
    return _ActionFormAPI.default.fetchInstance(appId, formId, contactId).then(function (formInstance) {
      return (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.INSTANCE_FETCHED, (0, _immutable.fromJS)({
        appId: appId,
        formId: formId,
        contactId: contactId,
        formInstance: formInstance
      }));
    }).catch(function () {
      return (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.INSTANCE_FETCH_FAILED, (0, _immutable.fromJS)({
        appId: appId,
        contactId: contactId,
        formId: formId
      }));
    });
  },
  submitForm: function submitForm(actionFormData, dynamicForm, formValues) {
    var appId = actionFormData.get('appId');
    var formId = actionFormData.get('formId');
    var contactId = actionFormData.get('contactId');
    (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.FORM_SUBMISSION_REQUESTED, actionFormData);
    var fields = formValues.map(function (v) {
      return {
        fieldName: v.fieldName,
        label: v.label,
        value: (0, _isArray.default)(v.value) ? v.value.join(',') : v.value
      };
    });
    var requiredExtraProperties = (dynamicForm != null ? dynamicForm.get('requiredExtraProperties') : undefined) || [];
    return _ActionFormAPI.default.submitForm(actionFormData, {
      fields: fields,
      requiredExtraProperties: requiredExtraProperties
    }).then(function (submissionResponse) {
      return (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.FORM_SUBMITTED, (0, _immutable.fromJS)({
        appId: appId,
        contactId: contactId,
        formId: formId,
        submissionResponse: submissionResponse
      }));
    }).catch(function () {
      return (0, _Dispatch.dispatchImmediate)(_ActionFormActionTypes.default.FORM_SUBMISSION_FAILED, (0, _immutable.fromJS)({
        appId: appId,
        contactId: contactId,
        formId: formId
      }));
    });
  }
};
exports.default = _default;
module.exports = exports.default;